<template>
  <div :class="className">
    <div
      id="projectControlLeaveModal"
      ref="continueModal"
      class="reveal"
      data-reveal
    >
      <button
        id="project_control_confirm_close"
        type="button"
        class="close-button"
        aria-label="Close modal"
        @click="closeModal()"
      >
        <span aria-hidden="true">&times;</span>
      </button>
      <div class="tender-confirm clearfix">
        <p class="msg_hint">
          {{ warnMessage || $t('warn.leave.lost') }}
        </p>
        <div class="tender-confirm-button-bar row align-right nav_btn">
          <button
            id="project_control_confirm_discard"
            type="button"
            class="btn btn--darkblue"
            @click="continueTo()"
          >
            {{ $t('action.discardAndContinue') }}
          </button>
          <button
            id="project_control_confirm_save"
            type="button"
            class="btn btn--orange"
            @click="saveAndContinue()"
          >
            {{ $t('action.saveAndContinue') }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import EventBus from '@/utils/eventBus'
import navigation from '@/utils/navigation'
import types from '@/store/mutation-types'
import { mapGetters, mapActions, mapMutations } from 'vuex'

export default {
  name: 'ProjectControlLeaveModal',
  props: {
    className: {
      type: String,
      default: 'clearfix',
    },
  },

  data () {
    return {
      to: {},
      warnMessage: '',
      onDiscard: null,
      onSave: null,
    }
  },
  computed: {
    ...mapGetters('form', {
      isDirty: 'isPageDirty',
    }),
  },
  mounted () {
    EventBus.$on('modules_project_control_leave_do_nav', ({ to, message, onDiscard, onSave }) => {
      this.onDiscard = onDiscard || null
      this.onSave = onSave || null
      if (message) {
        this.warnMessage = message
        this.$nextTick(() => { this.doNav(to) })
      } else {
        this.doNav(to)
      }
    })
    EventBus.$on('modules_project_control_leave_close', () => {
      this.continueModal && this.continueModal.close()
      this.resetForm()
      this.resetMessage()
      this.clearLeaveCallbacks()
    })
  },
  destroyed () {
    EventBus.$off('modules_project_control_leave_do_nav')
    EventBus.$off('modules_project_control_leave_close')
    if (this.continueModal) {
      this.continueModal.destroy()
    }
    $('#projectControlLeaveModal').remove()
  },
  methods: {
    ...mapActions('user', ['logout']),
    ...mapMutations('form', {
      resetForm: types.RESET_STATE,
    }),
    resetMessage () {
      this.warnMessage = ''
    },
    clearLeaveCallbacks () {
      this.onDiscard = null
      this.onSave = null
    },
    async init () {
      if (!this.continueModal) {
        this.continueModal = await new Foundation.Reveal($('#projectControlLeaveModal'), {
          closeOnEsc: false,
          closeOnClick: false,
        })
      }
      $('#projectControlLeaveModal').parent().css('z-index', 9999)
    },
    closeModal () {
      this.resetMessage()
      this.clearLeaveCallbacks()
      this.continueModal.close()
    },
    async doNav (to) {
      if (this.isDirty || this.onDiscard || this.onSave) {
        await this.init()
        this.to = to
        this.continueModal.open()
      } else {
        this.nav()
      }
    },
    continueTo () {
      const discard = this.onDiscard
      this.resetMessage()
      this.clearLeaveCallbacks()
      this.continueModal.close()
      this.resetForm()
      if (typeof discard === 'function') {
        discard()
        return
      }
      this.nav()
    },
    saveAndContinue () {
      if (typeof this.onSave === 'function') {
        const save = this.onSave
        save((success) => {
          if (!success) {
            return
          }
          this.closeModal()
          this.resetForm()
        })
        return
      }
      EventBus.emit('modules_project_control_leave_save', {
        done: (success) => {
          if (!success) {
            return
          }
          this.closeModal()
          this.resetForm()
          this.nav()
        },
      })
    },
    nav () {
      if (this.to) {
        if (deep(this.to, 'params.action') === 'logout') {
          this.logout()
        } else {
          this.to.name
            ? this.$router.push({
              name: this.to.name,
              params: this.to.params,
              query: this.to.query,
            }) : this.$router.goBack()
        }
        this.to = {}
      } else {
        navigation.toHome()
      }
    },
  },
}
</script>

<style scoped lang="scss">
@import '~styles/popup';
#projectControlLeaveModal {
  width: 500px;
}
.msg_hint {
  font-weight: bold;
}
.reveal .close-button{
    right: 15px;
}
</style>
